import { SlickHelper, tryGetText } from "@serenity-is/corelib";
import { Column } from "@serenity-is/sleekgrid";

var oldSetDefaults = SlickHelper.setDefaults;
SlickHelper.setDefaults = function (columns: Column[], localTextPrefix: string) {
    for (var col of columns) {
        if (localTextPrefix != null && col.name) {
            col.name = tryGetText(localTextPrefix + col.name) || col.name;
        }

        if (col.sourceItem != null && col.toolTip == null && col.sourceItem.hint != null) {
            col.toolTip = col.sourceItem.hint;
        }
    }
    return oldSetDefaults(columns, localTextPrefix);
}
